import React, { useEffect,useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as cubActions from 'actions/cubActions';
import * as formActions from 'actions/formActions';
import TechnicianForm from 'components/technicians/TechnicianForm';
import Logger from 'util/Logger';
import {
  Header,
  HeaderButtonNav,
  HeaderButton,
  HeaderTitle
} from 'components/layout';
import * as operationsApi from 'api/operationsApi';
import { useParams,useNavigate } from 'react-router-dom';
import CubForm from './CubForm';

/*const propTypes = {
  actions: PropTypes.object
};*/
const CreateCubPage=({actions})=>{
  const { action: mode, id: cubId } = useParams();
  const [loaded, setLoaded] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [cub, setCub] = useState(null);
  const navigate = useNavigate();

useEffect(()=>{
  if(mode=='edit'){
    getCub(cubId);
  }
},[mode, cubId]);


    const getCub = async (id) => {
      const result = await operationsApi.getCub(id);
      setCub(result.data[0]);
      console.log(result.data)
      setLoaded(true);
    };

    const createOrUpdateSuccess = (message) => {
      setIsSubmitting(false);
      actions.getCubs();
      Logger.success(message);
      navigate('/cubs');
    };

    const createCub = async (formValues) => {
      setIsSubmitting(true);
      await operationsApi.createNewCub(formValues);
      createOrUpdateSuccess('New Cub Created').then(navigate('/cubs'));
    };
  
    const updateCub = async (formValues) => {
      setIsSubmitting(true);
      await operationsApi.updateCub(formValues);
      createOrUpdateSuccess('Cub Updated').then(navigate('/cubs'));
    };
  
    const cancel = () => {
      navigate('/cubs');
    };
  
    if (mode === 'edit' && !loaded) {
      return null;
    }
  
    return (
      <div>
        <Header>
          <HeaderButtonNav>
            <HeaderButton
              color="primary"
              onClick={cancel}
              ligature="clear"
            />
          </HeaderButtonNav>
          <HeaderTitle label={`Create/Edit Cub`} />
          <CubForm 
           onSubmit={
            mode === 'edit' ? updateCub : createCub
          }
        //  isSubmitting={this.state.isSubmitting}
          initialValues={mode === 'edit' ? cub : {}}
          
          />

        </Header>
     
      </div>
    );
  }
//}

CreateCubPage.propTypes = {  actions: PropTypes.object.isRequired}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...cubActions,
        ...formActions
      },
      dispatch
    )
  };
}

export default connect(null, mapDispatchToProps)(CreateCubPage);
